import React from 'react'
import "./retail.scss"
import OnlineAssistance from './sections/onlineAssistance'
import Letsgo from "../connectors/letsgo"
import ResoucesTickets from './sections/resoucesTickets'
import TicketsList from './sections/ticketsList'



function Tickets() {
  return (
    <div className='container-retail'>
        <div className='section-b2c-profits'>
          <OnlineAssistance />
        </div>
        <div className="section-numerous-processes">
          <ResoucesTickets />
        </div>
        <div className="section-product-performance-list">
          <TicketsList />
        </div>
        <div className="section-lets-go">
          <Letsgo />
        </div>
    </div>
  )
}

export default Tickets